const PurchaseInvoice_sample = [
  {
    orderData: {
      poit_id: "poit_id",
      store_id: "store_id",
      cmr_id: "cmr_id",
      cmr_phone_number: "cmr_phone_number",
      remarks: "remarks",
      poit_total_gst: "poit_total_gst",
      poit_total_discount: "poit_total_discount",
      poit_payment_status: "poit_payment_status",
      poit_transaction_id: "poit_transaction_id",
      poit_order_status: "poit_order_status",
      poit_payment_method: "poit_payment_method",
      poit_sub_total: "poit_sub_total",
      poit_billing_address: "poit_billing_address",
      poit_total_amount: "poit_total_amount",
      poit_round_off_value: "poit_round_off_value",
      poit_delivery_date: "poit_delivery_date",
      poit_document_date: "poit_document_date",
      cmr_code: "cmr_code",
      cmr_name: "cmr_name",
      created_date: "created_date",
      update_date: "update_date",
      inv_no: "inv_no",
      document_date: "document_date",
      tcs_or_tds_amount: "tcs_or_tds_amount",
      tcs_or_tds_percentage: "tcs_or_tds_percentage",
      tds_tcs_type: "tds_tcs_type",
      tcs_or_tds_percentage_id: "tcs_or_tds_percentage_id",
      poit_invoice_discount: "poit_invoice_discount",
      poit_invoice_discount_percentage: "poit_invoice_discount_percentage",
      poit_is_invoice_dis_percentage: "poit_is_invoice_dis_percentage",
      pcns_total: "pcns_total",
      claimed_adjusted: "claimed_adjusted",
      remaining_balance: "remaining_balance",
      pcn_net_balance: "pcn_net_balance",
      ledger_closing: "ledger_closing",
      customer_invoice_number: "customer_invoice_number",
      poit_ship_to_address: "poit_ship_to_address",
      poit_pay_to_address: "poit_pay_to_address",
      is_local_purchase: "is_local_purchase",
      on_behalf_of_name: "on_behalf_of_name",
      on_behalf_of_id: "on_behalf_of_id",
    },
    itemData: [
      {
        item_id: "item_id",
        item_code: "item_code",
        gort_id: "gort_id",
        pot_id: "pot_id",
        item_generic_name: "item_generic_name",
        item_name: "item_name",
        item_rack_location: "item_rack_location",
        item_unit_price: "item_unit_price",
        item_quantity: "item_quantity",
        item_schedule: "item_schedule",
        item_credit_quanity_remaining: "item_credit_quanity_remaining",
        item_discount_amount: "item_discount_amount",
        item_discount_percentage: "item_discount_percentage",
        item_tax_amount: "item_tax_amount",
        item_total_tax_percentage: "item_total_tax_percentage",
        item_total_amount: "item_total_amount",
        item_uom: "item_uom",
        item_gst: "item_gst",
        item_sgst: "item_sgst",
        item_cgst: "item_cgst",
        item_igst: "item_igst",
        item_free_quantity: "item_free_quantity",
        item_hsn: "item_hsn",
        item_manufacturer_id: "item_manufacturer_id",
        item_manufacturer_name: "item_manufacturer_name",
        item_pack_size: "item_pack_size",
        base_quantity: "base_quantity",
        itemBatchData: [
          {
            item_id: "item_id",
            item_batch_number: "item_batch_number",
            item_sellable_quantity: "item_sellable_quantity",
            item_non_sellable_quantity: "item_non_sellable_quantity",
            item_exp_date: "item_exp_date",
            item_mfg_date: "item_mfg_date",
            item_batch_free_quantity: "item_batch_free_quantity",
            item_batch_unit_price: "item_batch_unit_price",
            item_batch_purchase_rate: "item_batch_purchase_rate",
            item_batch_discount_percentage: "item_batch_discount_percentage",
            item_batch_discount_amount: "item_batch_discount_amount",
            item_batch_tax_amount: "item_batch_tax_amount",
            item_batch_tax_percentage: "item_batch_tax_percentage",
            item_batch_final_purchase_rate: "item_batch_final_purchase_rate",
            item_batch_total_purchase_rate: "item_batch_total_purchase_rate",
            to_bin_id: "to_bin_id",
            to_bin_location: "to_bin_location",
            item_batch_total_effective_qauntity: "item_batch_total_effective_qauntity",
            item_batch_for_qauntity: "item_batch_for_qauntity",
            item_batch_for_free_qauntity: "item_batch_for_free_qauntity",
            item_batch_scheme_discount_percentage: "item_batch_scheme_discount_percentage",
            item_batch_scheme_discount_amount: "item_batch_scheme_discount_amount",
            item_batch_scheme_purchase_rate: "item_batch_scheme_purchase_rate",
            item_batch_discounted_purchase_rate: "item_batch_discounted_purchase_rate",
            item_batch_taxable_amount: "item_batch_taxable_amount",
            item_batch_total_base_purchase_rate: "item_batch_total_base_purchase_rate",
            item_batch_gen_discount_amount: "item_batch_gen_discount_amount",
          }
        ],
        total_sellable_quantity: "total_sellable_quantity",
      }
    ]
  }
];
const storeDetailsResult_sample = [
  {
    company: "COMAPNY_NAME",
    company_address: "COMPANY_LOCATION",
    company_telephone1: "COMPANY_PHONE",
    company_city: "COMPANY_CITY_CODE",
    company_gstn: "COMPANY_GST_NUMBER",
    company_email: "COMPANY_EMAIL",
    dl_no_20_20b: "DRUG_LICENSE_XX_XX",
    dl_no_21_21b: "DRUG_LICENSE_XX_XX",
    dl_no_21c: "DRUG_LICENSE_21C",
    store_id: "STORE_ID",
    company_logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSQVa-2-bOT2c7AJwxiSHkrkwOkey9z9x16dA&s"
  }
];
export default {PurchaseInvoice_sample,storeDetailsResult_sample};